import { createAction, props } from '@ngrx/store';
import { PaginatedApiResponse } from '@wdx/clmi/api-services/models';
import { Notification, Query } from '@wdx/clmi/clmi-swagger-gen';
import { PaginationOptions } from '../../models/pagination-options';

export const getPage = createAction(
    '[Notifications] Get Page',
    props<{
        reset?: boolean;
        pageSize: number;
    }>(),
);

export const getPageSuccess = createAction(
    '[Notifications] Get Page Success',
    props<{
        reset?: boolean;
        notifications: PaginatedApiResponse<Notification>;
    }>(),
);

export const getPageFailure = createAction(
    '[Notifications] Get Page Failure',
    props<{
        error: Error;
    }>(),
);

export const setUnreadNotifications = createAction(
    '[Notifications] Set Unread Notifications',
    props<{
        unreadNotifications: number;
    }>(),
);

export const initialiseNotificationPopups = createAction(
    '[Notifications] Initialise Notification Popups',
);

export const refreshNotificationPopups = createAction(
    '[Notifications] Refresh Notification Popups',
);

export const loadNotificationPopupsSuccess = createAction(
    '[Notifications] Load Notification Popups Success',
    props<{
        notifications: PaginatedApiResponse<Notification>;
    }>(),
);

export const loadNotificationPopupsFailure = createAction(
    '[Notifications] Load Notification Popups Failure',
    props<{
        error: Error;
    }>(),
);

export const dismissNotificationPopup = createAction(
    '[Notifications] Dismiss Notification Popup',
    props<{
        notificationId: string;
    }>(),
);

export const getForView = createAction(
    `[Notifications] Get For View`,
    props<{
        paginationOptions: PaginationOptions;
        filters: Query;
    }>(),
);

export const getForViewSuccess = createAction(
    `[Notifications] Get For View Success`,
    props<{
        payload: PaginatedApiResponse<any>;
    }>(),
);

export const getForViewFailure = createAction(
    `[Notifications] Get For View Failure`,
    props<{
        error: Error;
    }>(),
);

export const markAsRead = createAction(
    '[Notifications] Mark As Read',
    props<{
        notifications: Notification[];
    }>(),
);

export const markAsReadSuccess = createAction(
    '[Notifications] Mark As Read Success',
    props<{
        notifications: Notification[];
    }>(),
);

export const markAsReadFailure = createAction(
    '[Notifications] Mark As Read Failure',
    props<{
        error: Error;
    }>(),
);

export const markAllAsRead = createAction('[Notifications] Mark All as Read');

export const markAllAsReadSuccess = createAction(
    '[Notifications] Mark All as Read Success',
);

export const markAllAsReadFailure = createAction(
    '[Notifications] Mark All as Read Failure',
    props<{
        error: Error;
    }>(),
);
